export function navTrailAccess(g) {
    return {
        canSeeAllAccounts: (g.isSystemAdmin || g.viewableAccountCount >= 2) && g.canOpenAccountDashboard,
        canOpenAccount: g.canOpenAccountDashboard,
        canOpenLocation: g.canOpenLocationDashboard,
    };
}
